<template>
  <article class="rounded-md border border-slate-200 bg-slate-50 p-3">
    <p class="text-sm text-foreground">
      {{ eventLog.human_readable_description }}
    </p>
    <div class="mt-2 flex flex-wrap gap-2 text-xs text-muted-foreground">
      <span>{{ userLabel }}</span>
      <span>•</span>
      <time :datetime="eventLog.created_at">{{ createdAtLabel }}</time>
    </div>
  </article>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  eventLog: {
    type: Object,
    required: true,
  },
})

const userLabel = computed(() => {
  if (typeof props.eventLog?.user?.name === 'string' && props.eventLog.user.name.length > 0) {
    return props.eventLog.user.name
  }

  return 'System'
})

const createdAtLabel = computed(() => {
  if (typeof props.eventLog?.created_at !== 'string' || props.eventLog.created_at.length === 0) {
    return '-'
  }

  const date = new Date(props.eventLog.created_at)
  if (Number.isNaN(date.getTime())) {
    return props.eventLog.created_at
  }

  return date.toLocaleString()
})
</script>
